export const desktopNotAvailableUrl = '/desktop-not-available';
export const regionNotAvailableUrl = '/region-not-available';
